module.exports = __webpack_public_path__ + "static/brand2-1aa6f01dbcc3c1918479f1fe02f04a82.png";